import script from "./MeetingRoomFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingRoomFooter.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingRoomFooter.vue?vue&type=style&index=0&id=6ac1c1e6&scoped=true&lang=scss"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac1c1e6"]])

export default __exports__